export const SET_CURRICULAS= "SET_CURRICULAS"


export const setCurriculas = (value: any) => {
    return { type: SET_CURRICULAS, value }
}